import React from 'react';

const MyOrders = () => {
    return (
        <div>
            <h1>My order Page</h1>
        </div>
    );
};

export default MyOrders;